import React, { useEffect, useRef, useState } from 'react';
import Select from 'react-select';
import { useForm } from "react-hook-form";
import { API_URL } from "../../../actions/index";

import { putMediaAction, getMediasPageAction } from '../../../actions/mediasActions';
import { useGlobalContext } from '../../context/GlobalContext';
import pdfIcon from '../../../assets/images/icons/pdf-icon.png';
import exelIcon from '../../../assets/images/icons/exel.png';
import edit from '../../../assets/images/icons/edit.svg';
import { companiesColors, langsOptions } from '../../../utils/utils';
import './medias.scss';

export default function EditMedia({ media , setEditMedia , theme, companyId , onSaved }) {

  const customStyles = {
    multiValue: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? companiesColors[theme] : companiesColors[theme] 
    }),
    multiValueLabel: (provided, state) => ({
      ...provided,
      color: 'white'
    }),
    container: (provided, state) => ({
      ...provided,
      width: '100%',
      marginTop:7,
      marginBottom:20,
    }),
    valueContainer: (provided, state) => ({
      ...provided,
      padding: "0px 5px"
    }),
    control: (provided, state) => ({
      ...provided,
      boxShadow: "none",
      minHeight: 44,
      borderRadius: 10,
      border: state.isFocused || state.isSelected ? "1px solid " + companiesColors[theme] : "1px solid #E0E3EF"
    })
  }
  const mediaRef = useRef();
  const [ selectedThumbnail , setSelectedThumbnail ] = useState();
  const [ selectedLangs, setSelectedLangs] = useState(langsOptions.filter((l) => media.langs.find((m) => m === l.value)));
  const [ isSchool , setIsSchool ] = useState(false);
  const [ withThumbnail , setWithThumbnail ] = useState(false);
  const [ showThumbnailList , setShowThumbnailList ] = useState(false);
  const [ thumbnailList , setThumbnailList ] = useState([]);
  const [ newFile, setNewFile ] = useState(null);
  const [ displayImgPreview , setDisplayImgPreview ] = useState(false);
  const [ displayVideoPreview , setDisplayVideoPreview ] = useState(false);
  const [ fileSizeError , setFileSizeError ] = useState();

  const { handleSubmit, register, setValue, watch, errors } = useForm();

  const [ context , dispatch ] = useGlobalContext();

  useEffect(() => {
    if (media.type === "school") {
      setIsSchool(true)
    }
    if (media.thumbnail) {
      setSelectedThumbnail(media.thumbnail)
    }
    if (media.extension === "mp4" || media.extension === "pdf" || media.extension === "csv") {
      setWithThumbnail(true);
    } else {
      setWithThumbnail(false);
    }
  },[media])

  useEffect(() => {
    if (!showThumbnailList || !companyId) {
      return;
    }
    getMediasPageAction(dispatch, {
      companyId,
      type: 'thumbnails',
      page: 1,
      limit: 50
    }).then((result) => setThumbnailList(result.files));
    // eslint-disable-next-line
  }, [showThumbnailList, companyId]);

  const submitMedia = (values)  => {
    const langs = selectedLangs?.map((l) => l.value);
    
    // Si un nouveau fichier est sélectionné, utiliser FormData
    if (newFile) {
      const formData = new FormData();
      formData.append("file", newFile, newFile.name);
      formData.append("title", values.title);
      formData.append("description", values.description);
      formData.append("alt", values.title);
      formData.append("langs", langs?.join(','));
      if (selectedThumbnail) {
        formData.append("thumbnail", selectedThumbnail);
      }
      formData.append("isPriority", values.isPriority || false);
      if (isSchool) {
        formData.append("type", "school");
      }
      
      putMediaAction(dispatch, media._id, formData, true);
    } else {
      // Sinon, envoyer les données en JSON comme avant
      const data = {
        ...values,
        langs,
        thumbnail: selectedThumbnail,
      }
      data.type = isSchool ? "school" : "";
      putMediaAction(dispatch, media._id, data, false);
    }
    
    setEditMedia();
    if (onSaved) {
      onSaved();
    }
  };

  function renderImg() {
    if (media.extension === "jpeg" || media.extension === "png" || media.extension === "svg" || media.extension === "svg+xml") {

      var i = new Image();
      i.src = API_URL +'/'+ media.path; 

      return (
        <div ref={mediaRef} id={"img" + media._id}>
          <img src={API_URL +'/'+ media.path} alt={media.alt} />
          <p className="size">fichier {media.extension} <br/>{i.naturalWidth > 0 && i.naturalHeight > 0 && <span>{i.naturalWidth} x {i.naturalHeight} px</span>}</p>
        </div>
      )
    } else if (media.extension === "mp4") {
      // getVideoHeight( API_URL +'/'+ media.path);
      return (
        <div ref={mediaRef} id={"video" + media._id}>
          <video controls="controls">
            <source src={API_URL +'/'+ media.path}  type={media.mimetype} />
          </video>
          <p className="size">fichier {media.extension}</p>
          {/* <p className="size">{videoSize}</p> */}
        </div>
      );
    } else if (media.extension === "pdf") {
      return (
        <div ref={mediaRef} id={"pdf" + media._id} >
          <img src={pdfIcon} className="file" alt={media.alt} />
          <p className="size">fichier pdf</p>
        </div>
      )
    } else if (media.extension === "csv") {
      return (
        <div ref={mediaRef} id={"file" + media._id} >
          <img src={exelIcon} className="file" alt={media.alt} />
          <p className="size">fichier csv</p>
        </div>
      )
    }
  };

  function onChangeFile(e) {
    setFileSizeError();
    setDisplayImgPreview(false);
    setDisplayVideoPreview(false);
    var fileInput = e.target;
    var preview = document.getElementById("preview-img-edit");
    var imgSrc;
  
    if (fileInput.files && fileInput.files[0]) {
      const file = fileInput.files[0];
      setNewFile(file);

      if (file.size/1024/1024 > 40 && file.type === "video/mp4" ) {
        setFileSizeError("Les fichiers vidéos ne doivent pas être supérieur à 40 MB");
        setNewFile(null);
        return;
      }
      if (file.size/1024/1024 > 5 && file.type !== "video/mp4" ) {
        setFileSizeError("Les fichiers ne doivent pas être supérieur à 5 MB");
        setNewFile(null);
        return;
      }

      imgSrc = new FileReader();
      
      imgSrc.onload = function(e) {
        if (preview && (
            file.type === "image/svg+xml" ||
            file.type === "image/jpeg" ||
            file.type === "image/png" 
          )) {
          preview.setAttribute('src', e.target.result);
        }
      }
  
      if (file.type === "application/pdf") {
        if (preview) {
          preview.setAttribute('src', pdfIcon);
        }
        setDisplayImgPreview(true);
        setWithThumbnail(true);
      }

      if (file.type === "image/svg+xml") {
        imgSrc.readAsDataURL(file);
        setDisplayImgPreview(true);
        setWithThumbnail(false);
      }

      if (file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || file.type === "text/csv" ) {
        if (preview) {
          preview.setAttribute('src', exelIcon);
        }
        setDisplayImgPreview(true);
        setWithThumbnail(true);
      }

      if (file.type === "image/jpeg" || file.type === "image/png" ) {
        imgSrc.readAsDataURL(file);
        setDisplayImgPreview(true);
        setWithThumbnail(false);
      }

      if (file.type === "video/mp4" ) {
        var video = document.getElementById("video-mp4-edit");
        if (video) {
          var reader = new FileReader();

          reader.onload = function(e) {
            video.setAttribute('src',  e.target.result);
          };

          reader.readAsDataURL(file);
        }
        setDisplayVideoPreview(true);
        setWithThumbnail(true);
      }
    } else {
      // Si aucun fichier n'est sélectionné, réinitialiser
      setNewFile(null);
    }
  }

  return (
    <form className="add-media-container" onSubmit={handleSubmit(submitMedia)}>
      
      <div className="image">
        {!newFile && renderImg()}
        {newFile && !displayVideoPreview && (
          <img id="preview-img-edit" src={pdfIcon} alt="uploaded img" className={displayImgPreview ? "preview" : "d-none"} />
        )}
        {newFile && (
          <video controls width="250" id="video-mp4-edit" className={displayVideoPreview ? "preview" : "d-none"} >
            <source type="video/mp4"/>
          </video>
        )}
        <label htmlFor="file-edit" className={`label-file btn primary ${theme}-bg`} style={{ marginTop: newFile ? '10px' : '0' }}>
          {newFile ? 'Changer le fichier' : 'Remplacer le fichier'}
        </label>
      </div>
      <input
        name="file"
        type="file"
        id="file-edit"
        onChange={(e) => onChangeFile(e)}
        className="input-file"
        ref={register()}
      />
      {fileSizeError && <p className="error">{fileSizeError}</p>}

      <label htmlFor="media-edit-title">Titre</label>
      <textarea
        id="media-edit-title"
        name="title"
        defaultValue={media.title}
        ref={register({
          required: "Compléter un titre",
        })}
      />
      <p className="error">{errors.title && errors.title.message}</p>

      <label htmlFor="media-edit-description">Description</label>
      <textarea
        id="media-edit-description"
        name="description"
        defaultValue={media.description}
        ref={register({
          required: "Compléter une description",
        })}
      />

      <label htmlFor="media-edit-langs">Langues</label>
      <Select
        inputId="media-edit-langs"
        styles={customStyles}
        value={selectedLangs}
        options={langsOptions}
        placeholder={'Sélectionner des langues'}
        onChange={setSelectedLangs}
        isMulti
      />

      {media.extension === "pdf" &&
        <div>
          <input id="setIsSchool"
            onChange={(e) => setIsSchool(e.target.checked)}
            type="checkbox" className="switch" checked={isSchool}
            />
          <label htmlFor="setIsSchool">Ne pas afficher dans la médiathèque</label>
        </div>
      }

      <div>
        <input
          id="media-edit-isPriority"
          name="isPriority"
          defaultChecked={media.isPriority}
          onChange={(e) => setValue('isPriority', e.target.checked)}
          ref={register()}
          type="checkbox"
          className="switch"
          />
        <label htmlFor="media-edit-isPriority">{watch('isPriority') ? <span>Média prioritaire</span> : <span>Média non prioritaire</span> }</label>
      </div>

      {withThumbnail && !isSchool && 
        <>
        <label 
          onClick={() => setShowThumbnailList(!showThumbnailList)}
          style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px', marginBottom:20, textDecoration:"underline" }}
        >
          <img src={edit} alt="edit"/>
          Miniature (format 294 x 390 px)
        </label>
        {showThumbnailList && (
          <div className="thumbnail-list">
            {thumbnailList.map((item , i )  => {
              return (
                <button
                  key={'button' +i}
                  type="button"
                  onClick={() => setSelectedThumbnail(item._id)}
                  className="thumbnail">
                  <img src={API_URL + '/' + item.path} className={`${selectedThumbnail === item._id ? "active" : ""} `} alt={item.title} />
                  {/*<p>{item.title}</p>*/}
                </button>
              )
            })}
          </div>
        )}
        </>
      }

      <div className="btn-container">
        <button className={`btn success`} type="submit">Valider</button>
      </div>
    </form>
  )
}
